import { createNewMessage, createNewPrivateMessage } from "./helper";

const chat = (state = [], action) => {
  switch (action.type) {
    case "ADD_NEW_USER_MESSAGE": {
      const { text, displayName, senderId } = action.payload;
      const message = createNewMessage(text, "client", displayName, senderId);
      return [...state, message];
    }

    case "ADD_NEW_RESPONSE_MESSAGE": {
      const { message } = action.payload;
      return [...state, message];
    }

    case "ADD_CHAT_HISTORY": {
      const { chatHistory } = action.payload;
      return [...chatHistory, ...state];
    }

    case "ADD_JOINED_MESSAGE": {
      const { message } = action.payload;
      return [...state, message];
    }

    case "CLEAR_STATE":
      return [];
    default:
      return state;
  }
};

export default chat;
